module.exports = __webpack_public_path__ + "fonts/SofiaProSemiBold-Italic.7096419b.ttf";